import {ActionCreatorDefinition, createAction} from "redux-ts";
import {EduTradingTradeContentTab} from "enum/EduTradingTradeContentTab";
import {EduTradingArticle} from "protocol/edutrading/EduTradingArticlesResponse";
import {EduTradingEconomicCalendarPeriod} from "protocol/edutrading/EduTradingEconomicCalendarPeriod";
import {EduTradingEconomicCalendarEvent} from "protocol/edutrading/EduTradingEconomicCalendarEventsResponse";
import {EduTradingChartTab} from "enum/EduTradingChartTab";
import {
    EduFilterDate,
    EduFilterValue, EduTradingBroker,
    EduTradingPackage,
    EduTradingPackageContent,
    PlaylistInfo
} from "core/redux/eduTrading/EduTradingReduxState";
import {TSMap} from "typescript-map";
import {EduTradingCryptoCalendarPeriod} from "protocol/edutrading/EduTradingCryptoCalendarPeriod";
import {EduTradingCryptoCalendarEvent} from "protocol/edutrading/EduTradingCryptoCalendarEventsResponse";
import {EduTradingMarketVideoType} from "protocol/edutrading/EduTradingMarketVideoType";
import {EduTradingMarketVideo} from "protocol/edutrading/EduTradingMarketVideosResponse";
import {CurrencyStrengthMeter} from "protocol/edutrading/EduTradingCurrencyStrengthMeterResponse";
import {Glossary} from "protocol/edutrading/EduTradingGlossaryResponse";
import {EduTradingNewsCategoryType} from "protocol/edutrading/EduTradingNewsCategoryType";
import {TrendAnalysisItem} from "protocol/edutrading/EduTradingTrendAnalysisResponse";
import {BooleanPayload} from "core/redux/StoreActions";
import {EduTreeCourse, EduTreeLesson} from "protocol/edutrading/GetEducationalContentTree";
import {RouteType} from "core/router/Routes";
import {EduTradingScannerType} from "enum/EduTradingScannerType";
import {EduTradingCurrencyStrengthType} from "protocol/edutrading/EduTradingCurrencyStrengthType";

export const EduTradingSetActiveBrokerType: string = "EduTradingSetActiveBroker";
export const EduTradingSetActivePackageType: string = "EduTradingSetActivePackage";
export const EduTradingSetActiveChartTabType: string = "EduTradingSetActiveChartTab";
export const EduTradingSetActiveTradeContentTabType: string = "EduTradingSetActiveTradeContentTab";
export const EduTradingSetActiveTradeMobileTabType: string = "EduTradingSetActiveTradeMobileTab";
export const EduTradingSetAvailableMobileChartType: string = "EduTradingSetAvailableMobileChart";
export const EduTradingGetActivePackageType: string = "EduTradingGetActivePackage";
export const EduTradingSetPackageTreeContentType: string = "EduTradingSetPackageTreeContent";
export const EduTradingSetPackagesType: string = "EduTradingSetPackages";
export const EduTradingSetPackagesContentType: string = "EduTradingSetPackagesContent";
export const EduTradingSetNavigationMenuExpandedType: string = "EduTradingSetNavigationMenuExpanded";
export const EduTradingSetNavigationMenuActiveType: string = "EduTradingSetNavigationMenuActive";
export const EduTradingFetchArticlesType: string = "EduTradingFetchArticles";
export const EduTradingSetArticlesType: string = "EduTradingSetArticles";
export const EduTradingFetchEconomicCalendarEventsType: string = "EduTradingFetchEconomicCalendarEvents";
export const EduTradingSetEconomicCalendarEventsType: string = "EduTradingSetEconomicCalendarEvents";
export const EduTradingSetEconomicCalendarPeriodType: string = "EduTradingSetEconomicCalendarPeriod";
export const EduTradingSetEconomicCalendarFiltersType: string = "EduTradingSetEconomicCalendarFilters";
export const EduTradingSetEconomicCalendarDateFilterType: string = "EduTradingSetEconomicCalendarDateFilter";
export const EduTradingSetLoadingTreeType: string = "EduTradingSetLoadingTree";
export const EduTradingSetLoadingType: string = "EduTradingSetLoading";
export const EduTradingFetchCryptoCalendarEventsType: string = "EduTradingFetchCryptoCalendarEvents";
export const EduTradingSetCryptoCalendarEventsType: string = "EduTradingSetCryptoCalendarEvents";
export const EduTradingSetCryptoCalendarPeriodType: string = "EduTradingSetCryptoCalendarPeriod";
export const EduTradingSetCryptoCalendarFiltersType: string = "EduTradingSetCryptoCalendarFilters";
export const EduTradingSetCryptoCalendarDateFilterType: string = "EduTradingSetCryptoCalendarDateFilter";
export const EduTradingFetchMarketVideosType: string = "EduTradingFetchMarketSearchVideos";
export const EduTradingSetMarketSearchVideosType: string = "EduTradingSetMarketSearchVideos";
export const EduTradingFetchCurrencyStrengthMeterType: string = "EduTradingFetchCurrencyStrengthMeter";
export const EduTradingSetCurrencyStrengthMeterType: string = "EduTradingSetCurrencyStrengthMeter";
export const EduTradingFetchGlossaryType: string = "EduTradingFetchGlossary";
export const EduTradingSetGlossaryType: string = "EduTradingSetGlossary";
export const EduTradingFetchTrendAnalysisType: string = "EduTradingFetchTrendAnalysis";
export const EduTradingSetTrendAnalisysType: string = "EduTradingSetTrendAnalisys";
export const EduTradingSetActiveNewsTabType: string = "EduTradingSetActiveNewsTab";
export const EduTradingSetTrendAnalysisMarketType: string = "EduTradingSetTrendAnalysisMarket";
export const EduTradingSetActiveMarketVideoTabType: string = "EduTradingSetActiveMarketVideoTab";
export const EduTradingSetShowSearchContentType: string = "EduTradingSetShowSearchContent";
export const EduTradingSetSearchValueType: string = "EduTradingSetSearchValue";
export const EduTradingSetShowNotificationsType: string = "EduTradingSetShowNotifications";
export const EduTradingCompleteLessonType: string = "EduTradingCompleteLesson";
export const EduTradingSetLessonsCountType: string = "EduTradingSetLessonsCount";
export const EduTradingSetAcademyPlaylistProgressType: string = "EduTradingSetAcademyPlaylistProgress";
export const EduTradingSetTrendAnalysisAssetType: string = "EduTradingSetTrendAnalysisAsset";
export const EduTradingSetTrendAnalysisResolutionType: string = "EduTradingSetTrendAnalysisResolution";

export interface EduTradingSetActiveBrokerPayload {

    broker?: EduTradingBroker;
}

export interface EduTradingSetActivePackagePayload {

    Package: EduTradingPackage;
}

export interface EduTradingSetActiveChartTabPayload {

    Tab: EduTradingChartTab;
}

export interface EduTradingSetActiveTradeContentTabPayload {

    Tab: EduTradingTradeContentTab;
}

export interface EduTradingSetActiveTradeMobileTabPayload {

    Tab: EduTradingTradeContentTab;
}

export interface EduTradingSetPackageTreeContentPayload {

    Courses: EduTreeCourse[];
    EBooks: EduTreeLesson[];
    MarketAnalysis: EduTreeLesson[];
    MarketScanners: EduTreeLesson[];
    Tools: EduTreeLesson[];
    MinPackageConfig: {[key: string]: string};
}

export interface EduTradingSetPackagesPayload {

    Packages: EduTradingPackage[];
}

export interface EduTradingSetPackagesContentPayload {

    PackagesContent: TSMap<number, EduTradingPackageContent>;
}

export interface EduTradingSetNavigationMenuExpandedPayload {

    routeType: RouteType;
    expanded: boolean;
}

export interface EduTradingSetNavigationMenuActivePayload {

    routeType: RouteType | EduTradingScannerType,
    params: {id?: string}
}

export interface EduTradingSetArticlesPayload {

    Articles: EduTradingArticle[];
    articleType: EduTradingNewsCategoryType;
}

export interface EduTradingFetchEconomicCalendarEventsPayload {

    Period?: EduTradingEconomicCalendarPeriod;
    dateFilter?: EduFilterDate;
}

export interface EduTradingSetEconomicCalendarEventsPayload {

    Events: EduTradingEconomicCalendarEvent[];
}

export interface EduTradingSetEconomicCalendarPeriodPayload {

    period: EduTradingEconomicCalendarPeriod;
}

export interface EduTradingSetEconomicCalendarFiltersPayload {

    filters: TSMap<string, EduFilterValue[]>;
}


export interface EduTradingSetEconomicCalendarDateFilterPayload {

    dateFilter: EduFilterDate;
}


export interface EduTradingFetchCryptoCalendarEventsPayload {

    Period?: EduTradingCryptoCalendarPeriod;
    dateFilter?: EduFilterDate;
}

export interface EduTradingSetCryptoCalendarEventsPayload {

    cryptoEvents: EduTradingCryptoCalendarEvent[];
}

export interface EduTradingSetCryptoCalendarPeriodPayload {

    period?: EduTradingCryptoCalendarPeriod;
}

export interface EduTradingSetCryptoCalendarDateFilterPayload {

    dateFilter: EduFilterDate;
}

export interface EduTradingFiltersPayload {

    filters: TSMap<string, EduFilterValue[]>;
}

export interface EduTradingFetchMarketVideosPayload {

    videoType: EduTradingMarketVideoType;
}

export interface EduTradingSetMarketSearchVideosPayload {

    videoType: EduTradingMarketVideoType;
    videos: EduTradingMarketVideo[];
}

export interface EduTradingSetCurrencyStrengthMeterPayload {

    currencies: CurrencyStrengthMeter[];
}

export interface EduTradingSetGlossaryPayload {

    glossary: Glossary[];
}

export interface EduTradingFetchArticlesPayload {

    articleType: EduTradingNewsCategoryType;
}

export interface EduTradingSetTrendAnalisysPayload {

    trendAnalysis: TrendAnalysisItem[];
}

export interface EduTradingSetActiveNewsTabPayload {

    categoryType: EduTradingNewsCategoryType;
    tab: string;
}

export interface EduTradingSetTrendAnalysisMarketPayload {

    market: string;
}

export interface EduTradingSetActiveMarketVideoTabPayload {

    category: EduTradingMarketVideoType;
    tab: string;
}

export interface EduTradingSetShowSearchContentPayload {

    page: string;
    show: boolean;
}

export interface EduTradingSetSearchValuePayload {

    page: string;
    value: string;
}

export interface EduTradingSetShowNotificationsPayload {

    value: boolean;
}

export interface EduTradingCompleteLessonPayload {

    lessonGuid: string;
    courseId?: number;
}

export interface EduTradingSetLessonsCountPayload {

    all: number;
    completed: number;
}

export interface EduTradingSetAcademyPlaylistProgressPayload {

    data: TSMap<number, PlaylistInfo>;
}

export interface EduTradingSetLoadingPayload extends BooleanPayload{

    page: RouteType;
}

export interface EduTradingSetTrendAnalysisAssetPayload {

    asset: string;
}

export interface EduTradingSetTrendAnalysisResolutionPayload {

    resolution: EduTradingCurrencyStrengthType;
}

export const EduTradingSetActiveBroker: ActionCreatorDefinition<EduTradingSetActiveBrokerPayload, any> = createAction<EduTradingSetActiveBrokerPayload>(EduTradingSetActiveBrokerType);
export const EduTradingSetActivePackage: ActionCreatorDefinition<EduTradingSetActivePackagePayload, any> = createAction<EduTradingSetActivePackagePayload>(EduTradingSetActivePackageType);
export const EduTradingSetActiveChartTab: ActionCreatorDefinition<EduTradingSetActiveChartTabPayload, any> = createAction<EduTradingSetActiveChartTabPayload>(EduTradingSetActiveChartTabType);
export const EduTradingSetActiveTradeContentTab: ActionCreatorDefinition<EduTradingSetActiveTradeContentTabPayload, any> = createAction<EduTradingSetActiveTradeContentTabPayload>(EduTradingSetActiveTradeContentTabType);
export const EduTradingSetActiveTradeMobileTab: ActionCreatorDefinition<EduTradingSetActiveTradeMobileTabPayload, any> = createAction<EduTradingSetActiveTradeMobileTabPayload>(EduTradingSetActiveTradeMobileTabType);
export const EduTradingSetAvailableMobileChart: ActionCreatorDefinition<BooleanPayload, any> = createAction<BooleanPayload>(EduTradingSetAvailableMobileChartType);
export const EduTradingGetActivePackage: ActionCreatorDefinition<any, any> = createAction<any>(EduTradingGetActivePackageType);
export const EduTradingSetPackageTreeContent: ActionCreatorDefinition<EduTradingSetPackageTreeContentPayload, any> = createAction<EduTradingSetPackageTreeContentPayload>(EduTradingSetPackageTreeContentType);
export const EduTradingSetPackages: ActionCreatorDefinition<EduTradingSetPackagesPayload, any> = createAction<EduTradingSetPackagesPayload>(EduTradingSetPackagesType);
export const EduTradingSetPackagesContent: ActionCreatorDefinition<EduTradingSetPackagesContentPayload, any> = createAction<EduTradingSetPackagesContentPayload>(EduTradingSetPackagesContentType);
export const EduTradingSetNavigationMenuExpanded: ActionCreatorDefinition<EduTradingSetNavigationMenuExpandedPayload, any> = createAction<EduTradingSetNavigationMenuExpandedPayload>(EduTradingSetNavigationMenuExpandedType);
export const EduTradingSetNavigationMenuActive: ActionCreatorDefinition<EduTradingSetNavigationMenuActivePayload, any> = createAction<EduTradingSetNavigationMenuActivePayload>(EduTradingSetNavigationMenuActiveType);
export const EduTradingFetchArticles: ActionCreatorDefinition<EduTradingFetchArticlesPayload, any> = createAction<EduTradingFetchArticlesPayload>(EduTradingFetchArticlesType);
export const EduTradingSetArticles: ActionCreatorDefinition<EduTradingSetArticlesPayload, any> = createAction<EduTradingSetArticlesPayload>(EduTradingSetArticlesType);
export const EduTradingFetchEconomicCalendarEvents: ActionCreatorDefinition<EduTradingFetchEconomicCalendarEventsPayload, any> = createAction<EduTradingFetchEconomicCalendarEventsPayload>(EduTradingFetchEconomicCalendarEventsType);
export const EduTradingSetEconomicCalendarEvents: ActionCreatorDefinition<EduTradingSetEconomicCalendarEventsPayload, any> = createAction<EduTradingSetEconomicCalendarEventsPayload>(EduTradingSetEconomicCalendarEventsType);
export const EduTradingSetEconomicCalendarPeriod: ActionCreatorDefinition<EduTradingSetEconomicCalendarPeriodPayload, any> = createAction<EduTradingSetEconomicCalendarPeriodPayload>(EduTradingSetEconomicCalendarPeriodType);
export const EduTradingSetEconomicCalendarFilters: ActionCreatorDefinition<EduTradingSetEconomicCalendarFiltersPayload, any> = createAction<EduTradingSetEconomicCalendarFiltersPayload>(EduTradingSetEconomicCalendarFiltersType);
export const EduTradingSetEconomicCalendarDateFilter: ActionCreatorDefinition<EduTradingSetEconomicCalendarDateFilterPayload, any> = createAction<EduTradingSetEconomicCalendarDateFilterPayload>(EduTradingSetEconomicCalendarDateFilterType);
export const EduTradingSetLoadingTree: ActionCreatorDefinition<BooleanPayload, any> = createAction<BooleanPayload>(EduTradingSetLoadingTreeType);
export const EduTradingSetLoading: ActionCreatorDefinition<EduTradingSetLoadingPayload, any> = createAction<EduTradingSetLoadingPayload>(EduTradingSetLoadingType);
export const EduTradingFetchCryptoCalendarEvents: ActionCreatorDefinition<EduTradingFetchCryptoCalendarEventsPayload, any> = createAction<EduTradingFetchCryptoCalendarEventsPayload>(EduTradingFetchCryptoCalendarEventsType);
export const EduTradingSetCryptoCalendarEvents: ActionCreatorDefinition<EduTradingSetCryptoCalendarEventsPayload, any> = createAction<EduTradingSetCryptoCalendarEventsPayload>(EduTradingSetCryptoCalendarEventsType);
export const EduTradingSetCryptoCalendarPeriod: ActionCreatorDefinition<EduTradingSetCryptoCalendarPeriodPayload, any> = createAction<EduTradingSetCryptoCalendarPeriodPayload>(EduTradingSetCryptoCalendarPeriodType);
export const EduTradingSetCryptoCalendarDateFilter: ActionCreatorDefinition<EduTradingSetCryptoCalendarDateFilterPayload, any> = createAction<EduTradingSetCryptoCalendarDateFilterPayload>(EduTradingSetCryptoCalendarDateFilterType);
export const EduTradingSetCryptoCalendarFilters: ActionCreatorDefinition<EduTradingFiltersPayload, any> = createAction<EduTradingFiltersPayload>(EduTradingSetCryptoCalendarFiltersType);
export const EduTradingFetchMarketVideos: ActionCreatorDefinition<EduTradingFetchMarketVideosPayload, any> = createAction<EduTradingFetchMarketVideosPayload>(EduTradingFetchMarketVideosType);
export const EduTradingSetMarketSearchVideos: ActionCreatorDefinition<EduTradingSetMarketSearchVideosPayload, any> = createAction<EduTradingSetMarketSearchVideosPayload>(EduTradingSetMarketSearchVideosType);
export const EduTradingFetchCurrencyStrengthMeter: ActionCreatorDefinition<any, any> = createAction<any>(EduTradingFetchCurrencyStrengthMeterType);
export const EduTradingSetCurrencyStrengthMeter: ActionCreatorDefinition<EduTradingSetCurrencyStrengthMeterPayload, any> = createAction<EduTradingSetCurrencyStrengthMeterPayload>(EduTradingSetCurrencyStrengthMeterType);
export const EduTradingFetchGlossary: ActionCreatorDefinition<any, any> = createAction<any>(EduTradingFetchGlossaryType);
export const EduTradingSetGlossary: ActionCreatorDefinition<EduTradingSetGlossaryPayload, any> = createAction<EduTradingSetGlossaryPayload>(EduTradingSetGlossaryType);
export const EduTradingFetchTrendAnalysis: ActionCreatorDefinition<any, any> = createAction<any>(EduTradingFetchTrendAnalysisType);
export const EduTradingSetTrendAnalisys: ActionCreatorDefinition<EduTradingSetTrendAnalisysPayload, any> = createAction<EduTradingSetTrendAnalisysPayload>(EduTradingSetTrendAnalisysType);
export const EduTradingSetActiveNewsTab: ActionCreatorDefinition<EduTradingSetActiveNewsTabPayload, any> = createAction<EduTradingSetActiveNewsTabPayload>(EduTradingSetActiveNewsTabType);
export const EduTradingSetTrendAnalysisMarket: ActionCreatorDefinition<EduTradingSetTrendAnalysisMarketPayload, any> = createAction<EduTradingSetTrendAnalysisMarketPayload>(EduTradingSetTrendAnalysisMarketType);
export const EduTradingSetActiveMarketVideoTab: ActionCreatorDefinition<EduTradingSetActiveMarketVideoTabPayload, any> = createAction<EduTradingSetActiveMarketVideoTabPayload>(EduTradingSetActiveMarketVideoTabType);
export const EduTradingSetShowSearchContent: ActionCreatorDefinition<EduTradingSetShowSearchContentPayload, any> = createAction<EduTradingSetShowSearchContentPayload>(EduTradingSetShowSearchContentType);
export const EduTradingSetSearchValue: ActionCreatorDefinition<EduTradingSetSearchValuePayload, any> = createAction<EduTradingSetSearchValuePayload>(EduTradingSetSearchValueType);
export const EduTradingSetShowNotifications: ActionCreatorDefinition<EduTradingSetShowNotificationsPayload, any> = createAction<EduTradingSetShowNotificationsPayload>(EduTradingSetShowNotificationsType);
export const EduTradingCompleteLesson: ActionCreatorDefinition<EduTradingCompleteLessonPayload, any> = createAction<EduTradingCompleteLessonPayload>(EduTradingCompleteLessonType);
export const EduTradingSetLessonsCount: ActionCreatorDefinition<EduTradingSetLessonsCountPayload, any> = createAction<EduTradingSetLessonsCountPayload>(EduTradingSetLessonsCountType);
export const EduTradingSetAcademyPlaylistProgress: ActionCreatorDefinition<EduTradingSetAcademyPlaylistProgressPayload, any> = createAction<EduTradingSetAcademyPlaylistProgressPayload>(EduTradingSetAcademyPlaylistProgressType);
export const EduTradingSetTrendAnalysisAsset: ActionCreatorDefinition<EduTradingSetTrendAnalysisAssetPayload, any> = createAction<EduTradingSetTrendAnalysisAssetPayload>(EduTradingSetTrendAnalysisAssetType);
export const EduTradingSetTrendAnalysisResolution: ActionCreatorDefinition<EduTradingSetTrendAnalysisResolutionPayload, any> = createAction<EduTradingSetTrendAnalysisResolutionPayload>(EduTradingSetTrendAnalysisResolutionType);
